import { call, put } from 'redux-saga/effects';
import ActionTypes from '@ziynx/action-types';
import { FILTER_SLOTS } from '../../constants/filterSlots';

type SearchAction = {
  type: string,
  query?: {
    page: number,
    pageSize: number,
    name: string,
  },
}

export function* getLocation(action: SearchAction) {
  try {
    const response = yield call(() => APIService.apiRequest('GET_LOCATIONS_SEARCH', 'GET', {
      query: action?.query || {},
    }));

    yield put({
      type: ActionTypes.search.getLocation.SUCCESS,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.search.getLocation.ERROR,
      error,
    });
  }
}

export function* getInterests(action: SearchAction) {
  try {
    const response = yield call(() => APIService.apiRequest('GET_INTERESTS_SEARCH', 'GET', {
      query: action?.query || {},
    }));

    yield put({
      type: ActionTypes.search.getInterests.SUCCESS,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.search.getInterests.ERROR,
      error,
    });
  }
}

export function* getGraduationYears(action: SearchAction) {
  try {
    const response = yield call(() => APIService.apiRequest('GET_GRADUATION_YEARS_SEARCH', 'GET', {
      query: action?.query || {},
    }));

    yield put({
      type: ActionTypes.search.getGraduationYears.SUCCESS,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.search.getGraduationYears.ERROR,
      error,
    });
  }
}

export function* getCollegeLeague(action: SearchAction) {
  try {
    const response = yield call(() => APIService.apiRequest('GET_COLLEGE_LEAGUE_SEARCH', 'GET', {
      query: action?.query || {},
      routeParams: {
        slotId: FILTER_SLOTS.collegeOrLeague,
      },
    }));

    yield put({
      type: ActionTypes.search.getCollegeLeague.SUCCESS,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.search.getCollegeLeague.ERROR,
      error,
    });
  }
}

export function* getCharacterTraits(action: SearchAction) {
  try {
    const response = yield call(() => APIService.apiRequest('GET_CHARACTER_TRAITS_SEARCH', 'GET', {
      query: action?.query || {},
      routeParams: {
        slotId: FILTER_SLOTS.characterTraits,
      },
    }));

    yield put({
      type: ActionTypes.search.getCharacterTraits.SUCCESS,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.search.getCharacterTraits.ERROR,
      error,
    });
  }
}

export function* getJobLocation(action: SearchAction) {
  try {
    const response = yield call(() => APIService.apiRequest('GET_JOB_LOCATIONS_SEARCH', 'GET', {
      query: action?.query || {},
    }));

    yield put({
      type: ActionTypes.search.getJobLocation.SUCCESS,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.search.getJobLocation.ERROR,
      error,
    });
  }
}

export function* getCompanies(action: SearchAction) {
  try {
    const response = yield call(() => APIService.apiRequest('GET_COMPANIES_SEARCH', 'GET', {
      query: {
        ...action?.query,
        page: action?.query?.page || 0,
        pageSize: 10,
      } || {},
    }));

    yield put({
      type: ActionTypes.search.getCompanies.SUCCESS,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.search.getCompanies.ERROR,
      error,
    });
  }
}

export function* getCompanyQuestions(action: SearchAction) {
  try {
    const response = yield call(() => APIService.apiRequest('GET_COMPANY_QUESTIONS_SEARCH', 'GET', {
      query: {
        ...action?.query,
        page: action?.query?.page || 0,
        pageSize: 10,
      } || {},
    }));

    yield put({
      type: ActionTypes.search.getCompanyQuestions.SUCCESS,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.search.getCompanyQuestions.ERROR,
      error,
    });
  }
}
